import $ from 'jquery';

$(function() {
	if ($("#prevnextcolumn") != undefined && $("#prevnextcolumn1") != undefined &&$("#prevnextcolumn2") != undefined && $("#prevnextcolumn").children().length > 1) {
		if ($("#prevnextcolumn2").css("height") > $("#prevnextcolumn1").css("height")) {
			$("#prevnextcolumn1").css("height", $("#prevnextcolumn2").css("height"));
			$("#prevnextcolumn1 .activity-content").css("height", $("#prevnextcolumn2 .activity-content").css("height"));
		}
		else {
			$("#prevnextcolumn2").css("height", $("#prevnextcolumn1").css("height"));
			$("#prevnextcolumn2 .activity-content").css("height", $("#prevnextcolumn1 .activity-content").css("height"));
		}
	}
});
